import { createAction, props } from "@ngrx/store";

export const taskState = createAction(
  "[taskState] Set Task State",
  props<{ data: any }>()
);
